import { Alert, Button, Modal } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";

interface AuthActivationSuccessModalProps {
  isOpen: boolean;
  backupCodes: Array<string>;
  onToggle: () => void;
}

function AuthActivationSuccessModal({
  isOpen,
  backupCodes,
  onToggle
}: AuthActivationSuccessModalProps) {
  return (
    <Modal
      className="AuthActivationSuccessModal"
      opened={isOpen}
      title="Zwei-Faktor-Authentifizierung wurde aktiviert"
      onClose={onToggle}
    >
      <p>
        Der von Ihnen eingegebene Code ist korrekt. Die
        2-Faktor-Authentifizierung ist nun aktiv und Ihr Konto ist besser
        geschützt.
      </p>

      <p>
        Falls Sie den Zugang zu Ihrer primären Authentifizierungsmethode
        verlieren, müssen Sie die folgenden Backup-Codes verwenden um sich
        einzuloggen. Bitte bewahren Sie die Backup-Codes an einem sicheren Ort
        auf. Jeder Backup-Code kann nur ein Mal verwendet werden.
      </p>

      <p>
        <strong>Wichtig:</strong> Wenn Sie den Zugriff zur
        Authentifizierungsmethode und Backup-Codes verlieren, können Sie sich
        nicht mehr in Ihren Account einloggen!
      </p>

      <Alert color="neutral">
        {backupCodes.map((code) => (
          <span key={code}>
            {code}
            <br />
          </span>
        ))}
      </Alert>
      <ModalFooter>
        <Button color="secondary" onClick={onToggle}>
          Bestätigen
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { AuthActivationSuccessModal };
